import styled from 'styled-components';

export const StructurePlusBox = styled.div`
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.secondary100};
  opacity: ${(props) => (props.disabled ? '0.1' : '1')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
